const productOptions = [...document.querySelectorAll('.js-product-option')];
const literPriceContainer = document.querySelector('.js-liter-price-container');
const literPrice = literPriceContainer?.querySelector('.js-liter-price');
const sku = document.querySelector('.js-variant-sku');

if(literPrice || sku) {
    if(document.querySelector('.js-section__product-single')) {
        productOptions.map(productOption => {
            const literPriceData = productOption.dataset.literprice;
            const skuData = productOption.dataset.sku;

            const showLiterPrice = () => {
                if (productOption.checked && literPrice) {
                    if(literPriceData !== '0,00') {
                        literPriceContainer.setAttribute('data-active', 'true');
                        literPrice.innerHTML = literPriceData;
                    } else {
                        literPriceContainer.removeAttribute('data-active');
                        literPrice.innerHTML = '0,00';
                    }
                }
            }

            const showSKU = () => {
                if (productOption.checked && sku) {
                    sku.innerHTML = skuData;
                }
            }

            productOption.addEventListener('change', () => {
                showLiterPrice();
                showSKU();
            });

            showLiterPrice();
            showSKU();
        });
    } else {
        [...document.querySelectorAll('.js-product-card')].map(productCard => {
            const productOptionsProductCard = [...productCard.querySelectorAll('.js-product-option')];
            const literPriceContainerProductBlock = productCard.querySelector('.js-liter-price-container');
            const literPriceProductBlock = literPriceContainerProductBlock?.querySelector('.js-liter-price');

            productOptionsProductCard.map(productOption => {
                let literPriceDataProductBlock = productOption.dataset.literprice;


                const showLiterPriceProductBlock = () => {
                    if (productOption.checked && literPrice) {
                        if(literPriceDataProductBlock !== '0,00') {
                            literPriceContainerProductBlock.setAttribute('data-active', 'true');
                            literPriceProductBlock.innerHTML = literPriceDataProductBlock;
                        } else {
                            literPriceContainerProductBlock.removeAttribute('data-active');
                            literPriceProductBlock.innerHTML = '0,00';
                        }
                    }

                }


                productOption.addEventListener('change', () => {
                    showLiterPriceProductBlock();
                });

                showLiterPriceProductBlock();
            });

        })
    }
}
